import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { validateEditorData } from '../../../editor/defaultOptions.js';
import { FormError } from '../../../FormError.jsx';
import FormStepsNav from './FormStepsNav.jsx';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';
import EmployeesFormField from '../../../employees-form-field/EmployeesFormField.jsx';
import AuthorizedAction from '../../../AuthorizedAction.js';

import Editor from '../../../editor/editor.jsx';

function StepCommunicatorsForm(props) {
  const {
    handleSubmit,
    onCancel,
    onSelectEmployee,
    selectedTrustedCommunicators,
    setCommentEditorInstance,
    addVersionComment,
    onShowEmployeeModal,
    onBack,
    submitting,
    submitFailed,
    submitError,
    values,
  } = props;
  return (
    <form>
      <Row>
        <Col xs={12}>
          <FormStepsNav activeIndex={3} onBack={onBack} />
        </Col>
        <Col xs={12}>
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>Select Trusted Communicators</h3>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={8} className="m-b-24">
          <p className="text-muted m-b-24">
            If needed, select individuals or leaders that this Stakeholder
            trusts as a reliable source of important information.
          </p>
          <Field
            id="trustedCommunicators"
            name="trustedCommunicators"
            selected={selectedTrustedCommunicators}
            handleSelect={onSelectEmployee}
            title="Trusted Communicators"
            isItemActive={(val) =>
              selectedTrustedCommunicators.some(({ id }) => id === val)
            }
            component={EmployeesFormField}
            addBtn={
              <AuthorizedAction action="create" subject="employee">
                <button
                  type="button"
                  className="btn-link"
                  onClick={onShowEmployeeModal}
                >
                  {' '}
                  + Add People
                </button>
              </AuthorizedAction>
            }
          />
        </Col>
      </Row>
      <Row style={{ display: !addVersionComment ? 'none' : '' }}>
        <Col xs={8}>
          <p className="communication-help text-muted m-b-24">
            Add optional comment about changes in Influence, Interest, Impact.
          </p>
          <Field name="changesComment">
            {({ name, input }) => {
              return (
                <Editor
                  name={name || ''}
                  data={validateEditorData(input.value)}
                  label=""
                  setEditorInstanceForParent={setCommentEditorInstance}
                  options={{
                    holder: 'comment-stakeholder-editor',
                  }}
                />
              );
            }}
          </Field>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          {submitFailed && submitError ? (
            <FormError submitError={submitError} />
          ) : null}
        </Col>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={submitting}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
            finalStep
          />
        </Col>
      </Row>
    </form>
  );
}

export default StepCommunicatorsForm;
